import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sobre',
    element: <AboutPage />,
  },
  {
    path: '/produtos',
    element: <ProductsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;